import { EditableText } from './editable-text';
import { usePageByNumber } from './blueprint-pages-context';

export type BlueprintPageFooterProps = {
	pageNumber: number;
};

const MONTHS: Array<string> = [
	'January', 'February', 'March', 'April', 'May', 'June',
	'July', 'August', 'September', 'October', 'November', 'December'
];

/**
 * Matches the PDF formatDate helper: "18th March, 2026"
 */
const formatFooterDate = (date: Date): string => {
	const day = date.getDate();
	const month = MONTHS[date.getMonth()];
	const year = date.getFullYear();

	let daySuffix = 'th';
	switch (day) {
		case 1:
		case 21:
		case 31:
			daySuffix = 'st';
			break;
		case 2:
		case 22:
			daySuffix = 'nd';
			break;
		case 3:
		case 23:
			daySuffix = 'rd';
			break;
		default:
			daySuffix = 'th';
	}

	return `${day}${daySuffix} ${month}, ${year}`;
};

export const BlueprintPageFooter = (props: BlueprintPageFooterProps): React.ReactElement => {
	const { pageNumber } = props;
	const dateString = formatFooterDate(new Date());
	const page = usePageByNumber(pageNumber);
	const scope = page?.overrideScope ?? `page.${pageNumber}`;
	const { legacyPageNumber } = page ?? {};
	const legacyKey = (field: string): string | undefined => {
		return legacyPageNumber === undefined ? undefined : `footer.${field}.${legacyPageNumber}`;
	};

	return (
		<div style={{
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			color: '#8394A4',
			fontFamily: "'Inter', sans-serif",
			flexShrink: 0
		}}>
			<EditableText overrideKey={`${scope}.footer.date`} legacyOverrideKey={legacyKey('date')} element='span'>{dateString}</EditableText>
			<EditableText overrideKey={`${scope}.footer.contactInfo`} legacyOverrideKey={legacyKey('contactInfo')} element='span'>info@rtaoutdoor.com | 1-800-827-1830</EditableText>
			<EditableText overrideKey={`${scope}.footer.pageNumber`} legacyOverrideKey={legacyKey('pageNumber')} element='span'>{pageNumber}</EditableText>
		</div>
	);
};
